// Textos propis de la pàgina "grupos" per idioma (Grupos.jsx).

const textos = {
    es: {
        heroImageAlt: "Grupos y deportistas en el Hotel Camprodon",
        heroSmallTitle: "¡Disfruta en grupo de un alojamiento en plena naturaleza!",
        heroTitle: "Grupos y deportistas en el Hotel Camprodon",
        presentationSmallTitle: "Alójate en grupo en el Hotel Camprodon",
        presentationTitle: "Hotel para grupos y deportistas",
        presentationContent: <>{"El Hotel Camprodon está preparado para "}<strong>recibir a grupos</strong>{" y satisfacer vuestras necesidades."}</>,
        fullSliderImgAlt: "Hotel para grupos y deportistas",
        fullSliderImgAlt2: "Hotel para grupos y deportistas",
        fullSliderImgAlt3: "Hotel para grupos y deportistas",
        sectionHeadSubtitle: "Ven a Camprodón en grupo",
        sectionHeadTitle: "Estamos preparados para recibir a grupos y deportistas",
        sectionHeadTexts: <><p>{"Nos gusta recibir "}<strong>concentraciones de equipos</strong>{" de futbol o básquet o patinaje o... así como grupos de amigos y "}<strong>{"deportistas "}</strong>que practiquen BTT o ciclismo de carretera. Tenemos garaje y espacio donde poner vuestras bicicletas a punto.</p><br /></>,
        list: "Menús adaptados",
        list2: <>{"Para los grupos, nos adaptamos a sus "}<strong>{"horarios "}</strong>{"y "}<strong>necesidades alimentarias</strong>{" y ofrecemos menús especiales."}</>,
        formTitle: "¿Quieres venir en grupo al Hotel Camprodon?",
        formContent: "Rellena este formulario y envíanos tu solicitud. Nos pondremos en contacto contigo a la mayor brevedad posible.",
        languageValue: "es",
        checkboxHref: "/politica-de-privacidad",
    },
    ca: {
        heroImageAlt: "Grups i esportistes a l'Hotel Camprodon",
        heroSmallTitle: "Gaudeix en grup d'un allotjament en plena natura!",
        heroTitle: "Grups i esportistes a l'Hotel Camprodon",
        presentationSmallTitle: "Allotja't en grup a l'Hotel Camprodon",
        presentationTitle: "Hotel per a grups i esportistes",
        presentationContent: <>L’Hotel Camprodon està preparat per a<strong>{" rebre grups"}</strong>{" i satisfer les vostres necessitats."}</>,
        fullSliderImgAlt: "Hotel per a grups i esportistes",
        fullSliderImgAlt2: "Hotel per a grups i esportistes",
        fullSliderImgAlt3: "Hotel per a grups i esportistes",
        sectionHeadSubtitle: "Vine a Camprodon en grup",
        sectionHeadTitle: "Estem preparats per rebre grups i esportistes",
        sectionHeadTexts: <><p>{"Ens agrada rebre "}<strong>concentracions d’equips de futbol</strong>{" o basquetbol, així com de grups d’amics i "}<strong>{"esportistes "}</strong>que practiquin BTT o ciclisme de carretera. Tenim garatge i espai on posar a punt les vostres bicicletes.</p></>,
        list: "Menús adaptats",
        list2: <>{"Per als grups, ens adaptem als vostres "}<strong>{"horaris "}</strong>{"i "}<strong>necessitats alimentàries</strong>, i oferim menús especials.</>,
        formTitle: "Vols venir en grup a l'Hotel Camprodon?",
        formContent: "Omple aquest formulari i envia'ns la teva sol·licitud. Ens posarem en contacte amb tu com més aviat millor.",
        languageValue: "ca",
        checkboxHref: "/ca/politica-de-privacitat",
    },
    en: {
        heroImageAlt: "Groups and athletes at Hotel Camprodon",
        heroSmallTitle: "Enjoy a group accommodation in the middle of nature!",
        heroTitle: "Groups and athletes at Hotel Camprodon",
        presentationSmallTitle: "Stay in a group at the Hotel Camprodon",
        presentationTitle: "Hotel for groups and athletes",
        presentationContent: <>Hotel Camprodon is well prepared to<strong>{" receive groups "}</strong>and meet your needs.</>,
        fullSliderImgAlt: "Hotel for groups and athletes",
        fullSliderImgAlt2: "Hotel for groups and athletes",
        fullSliderImgAlt3: "Hotel for groups and athletes",
        sectionHeadSubtitle: "Come to Camprodon in a group",
        sectionHeadTitle: "We are prepared to receive groups and athletes",
        sectionHeadTexts: <><p>{"We enjoy hosting "}<strong>sports teams</strong>{", as well as groups of friends and "}<strong>{"athletes "}</strong>who practice mountain biking or road cycling. We have parking space and an area to fix and attune your bike.</p></>,
        list: "Adapted menus",
        list2: <>{"For groups, we adapt to your "}<strong>schedule</strong><em></em>{"and "}<strong>food needs</strong>, and we offer special menus.</>,
        formTitle: "Do you want to come as a group to the Hotel Camprodon?",
        formContent: "Fill out this form and send us your request. We will contact you as soon as possible.",
        languageValue: "en",
        checkboxHref: "/en/privacy-policy",
    },
    fr: {
        heroImageAlt: "Groupes et sportifs à l'Hotel Camprodon",
        heroSmallTitle: "Profitez en groupe d'un hébergement en pleine nature !",
        heroTitle: "Groupes et sportifs à l'Hotel Camprodon",
        presentationSmallTitle: "Séjournez en groupe à l'Hotel Camprodon",
        presentationTitle: "Hôtel pour groupes et sportifs",
        presentationContent: <>{"L'Hotel Camprodon est prêt à "}<strong>accueillir des groupes</strong>{" et à répondre à vos besoins."}</>,
        fullSliderImgAlt: "Hôtel pour groupes et sportifs",
        fullSliderImgAlt2: "Hôtel pour groupes et sportifs",
        fullSliderImgAlt3: "Hôtel pour groupes et sportifs",
        sectionHeadSubtitle: "Venez à Camprodon en groupe",
        sectionHeadTitle: "Nous sommes prêts à accueillir des groupes et des sportifs",
        sectionHeadTexts: <><p>{"Nous aimons accueillir des "}<strong>stages d'équipes</strong>{" de football, de basket, de patinage... ainsi que des groupes d'amis et des "}<strong>sportifs</strong>{" pratiquant le VTT ou le cyclisme sur route. Nous avons un garage et un espace pour préparer vos vélos."}</p><br /></>,
        list: "Menus adaptés",
        list2: <>{"Pour les groupes, nous nous adaptons à vos "}<strong>horaires</strong>{" et à vos "}<strong>besoins alimentaires</strong>, et proposons des menus spéciaux.</>,
        formTitle: "Vous souhaitez venir en groupe à l'Hotel Camprodon ?",
        formContent: "Remplissez ce formulaire et envoyez-nous votre demande. Nous vous contacterons dans les plus brefs délais.",
        languageValue: "fr",
        checkboxHref: "/fr/politique-de-confidentialite",
    },
    de: {
        heroImageAlt: "Gruppen und Sportler im Hotel Camprodon",
        heroSmallTitle: "Genießen Sie als Gruppe eine Unterkunft mitten in der Natur!",
        heroTitle: "Gruppen und Sportler im Hotel Camprodon",
        presentationSmallTitle: "Übernachten Sie als Gruppe im Hotel Camprodon",
        presentationTitle: "Hotel für Gruppen und Sportler",
        presentationContent: <>{"Das Hotel Camprodon ist bereit, "}<strong>Gruppen zu empfangen</strong>{" und auf Ihre Bedürfnisse einzugehen."}</>,
        fullSliderImgAlt: "Hotel für Gruppen und Sportler",
        fullSliderImgAlt2: "Hotel für Gruppen und Sportler",
        fullSliderImgAlt3: "Hotel für Gruppen und Sportler",
        sectionHeadSubtitle: "Kommen Sie als Gruppe nach Camprodon",
        sectionHeadTitle: "Wir sind bereit für Gruppen und Sportler",
        sectionHeadTexts: <><p>{"Wir empfangen gerne "}<strong>Trainingslager von Mannschaften</strong>{" aus Fußball, Basketball, Eislauf ... sowie Freundesgruppen und "}<strong>Sportler</strong>, die Mountainbike oder Rennrad fahren. Wir haben eine Garage und Platz, um Ihre Fahrräder startklar zu machen.</p><br /></>,
        list: "Angepasste Menüs",
        list2: <>{"Für Gruppen passen wir uns an Ihre "}<strong>Zeiten</strong>{" und "}<strong>Ernährungsbedürfnisse</strong>{" an und bieten spezielle Menüs."}</>,
        formTitle: "Möchten Sie als Gruppe ins Hotel Camprodon kommen?",
        formContent: "Füllen Sie dieses Formular aus und senden Sie uns Ihre Anfrage. Wir melden uns so schnell wie möglich bei Ihnen.",
        languageValue: "de",
        checkboxHref: "/de/privacy-policy",
    },
    it: {
        heroImageAlt: "Gruppi e sportivi all'Hotel Camprodon",
        heroSmallTitle: "Goditi in gruppo un alloggio in piena natura!",
        heroTitle: "Gruppi e sportivi all'Hotel Camprodon",
        presentationSmallTitle: "Soggiorna in gruppo all'Hotel Camprodon",
        presentationTitle: "Hotel per gruppi e sportivi",
        presentationContent: <>{"L'Hotel Camprodon è pronto ad "}<strong>accogliere gruppi</strong>{" e a soddisfare le vostre esigenze."}</>,
        fullSliderImgAlt: "Hotel per gruppi e sportivi",
        fullSliderImgAlt2: "Hotel per gruppi e sportivi",
        fullSliderImgAlt3: "Hotel per gruppi e sportivi",
        sectionHeadSubtitle: "Vieni a Camprodon in gruppo",
        sectionHeadTitle: "Siamo pronti ad accogliere gruppi e sportivi",
        sectionHeadTexts: <><p>{"Ci piace ospitare "}<strong>ritiri di squadre</strong>{" di calcio, basket, pattinaggio... così come gruppi di amici e "}<strong>sportivi</strong>{" che praticano mountain bike o ciclismo su strada. Abbiamo un garage e uno spazio dove mettere a punto le vostre biciclette."}</p><br /></>,
        list: "Menù adattati",
        list2: <>{"Per i gruppi, ci adattiamo ai vostri "}<strong>orari</strong>{" e alle vostre "}<strong>esigenze alimentari</strong>{" e offriamo menù speciali."}</>,
        formTitle: "Vuoi venire in gruppo all'Hotel Camprodon?",
        formContent: "Compila questo modulo e inviaci la tua richiesta. Ti contatteremo il prima possibile.",
        languageValue: "it",
        checkboxHref: "/it/informativa-sulla-privacy",
    },
    pt: {
        heroImageAlt: "Grupos e desportistas no Hotel Camprodon",
        heroSmallTitle: "Desfrute em grupo de um alojamento em plena natureza!",
        heroTitle: "Grupos e desportistas no Hotel Camprodon",
        presentationSmallTitle: "Fique em grupo no Hotel Camprodon",
        presentationTitle: "Hotel para grupos e desportistas",
        presentationContent: <>{"O Hotel Camprodon está preparado para "}<strong>receber grupos</strong>{" e satisfazer as vossas necessidades."}</>,
        fullSliderImgAlt: "Hotel para grupos e desportistas",
        fullSliderImgAlt2: "Hotel para grupos e desportistas",
        fullSliderImgAlt3: "Hotel para grupos e desportistas",
        sectionHeadSubtitle: "Venha a Camprodon em grupo",
        sectionHeadTitle: "Estamos preparados para receber grupos e desportistas",
        sectionHeadTexts: <><p>{"Gostamos de receber "}<strong>estágios de equipas</strong>{" de futebol, basquetebol, patinagem... bem como grupos de amigos e "}<strong>desportistas</strong>{" que pratiquem BTT ou ciclismo de estrada. Temos garagem e espaço para afinar as vossas bicicletas."}</p><br /></>,
        list: "Menus adaptados",
        list2: <>{"Para os grupos, adaptamo-nos aos vossos "}<strong>horários</strong>{" e "}<strong>necessidades alimentares</strong>{" e oferecemos menus especiais."}</>,
        formTitle: "Quer vir em grupo ao Hotel Camprodon?",
        formContent: "Preencha este formulário e envie-nos o seu pedido. Entraremos em contacto consigo o mais brevemente possível.",
        languageValue: "pt",
        checkboxHref: "/pt/politica-de-privacidade",
    },
    nl: {
        heroImageAlt: "Groepen en sporters in Hotel Camprodon",
        heroSmallTitle: "Geniet met je groep van een verblijf midden in de natuur!",
        heroTitle: "Groepen en sporters in Hotel Camprodon",
        presentationSmallTitle: "Verblijf met je groep in Hotel Camprodon",
        presentationTitle: "Hotel voor groepen en sporters",
        presentationContent: <>{"Hotel Camprodon is klaar om "}<strong>groepen te ontvangen</strong>{" en aan jullie wensen te voldoen."}</>,
        fullSliderImgAlt: "Hotel voor groepen en sporters",
        fullSliderImgAlt2: "Hotel voor groepen en sporters",
        fullSliderImgAlt3: "Hotel voor groepen en sporters",
        sectionHeadSubtitle: "Kom met je groep naar Camprodon",
        sectionHeadTitle: "We zijn klaar om groepen en sporters te ontvangen",
        sectionHeadTexts: <><p>{"We ontvangen graag "}<strong>trainingskampen van teams</strong>{" in voetbal, basketbal, schaatsen... en ook vriendengroepen en "}<strong>sporters</strong>{" die mountainbiken of wielrennen. We hebben een garage en ruimte om jullie fietsen klaar te maken."}</p><br /></>,
        list: "Aangepaste menu's",
        list2: <>{"Voor groepen passen we ons aan jullie "}<strong>tijden</strong>{" en "}<strong>voedingsbehoeften</strong>{" aan en bieden we speciale menu's."}</>,
        formTitle: "Wil je met een groep naar Hotel Camprodon komen?",
        formContent: "Vul dit formulier in en stuur ons je aanvraag. We nemen zo snel mogelijk contact met je op.",
        languageValue: "nl",
        checkboxHref: "/nl/privacy-beleid",
    },
    cs: {
        heroImageAlt: "Skupiny a sportovci v hotelu Hotel Camprodon",
        heroSmallTitle: "Užijte si se skupinou ubytování uprostřed přírody!",
        heroTitle: "Skupiny a sportovci v hotelu Hotel Camprodon",
        presentationSmallTitle: "Ubytujte se se skupinou v hotelu Hotel Camprodon",
        presentationTitle: "Hotel pro skupiny a sportovce",
        presentationContent: <>{"Hotel Camprodon je připraven "}<strong>přijímat skupiny</strong>{" a vyjít vstříc vašim potřebám."}</>,
        fullSliderImgAlt: "Hotel pro skupiny a sportovce",
        fullSliderImgAlt2: "Hotel pro skupiny a sportovce",
        fullSliderImgAlt3: "Hotel pro skupiny a sportovce",
        sectionHeadSubtitle: "Přijeďte do Camprodonu se skupinou",
        sectionHeadTitle: "Jsme připraveni přijímat skupiny a sportovce",
        sectionHeadTexts: <><p>{"Rádi hostíme "}<strong>soustředění týmů</strong>{" fotbalu, basketbalu, bruslení... i skupiny přátel a "}<strong>sportovců</strong>, kteří jezdí na horském nebo silničním kole. Máme garáž a prostor, kde si můžete připravit kola.</p><br /></>,
        list: "Přizpůsobená menu",
        list2: <>{"Pro skupiny se přizpůsobíme vašemu "}<strong>časovému rozvrhu</strong>{" a "}<strong>stravovacím potřebám</strong>{" a nabízíme speciální menu."}</>,
        formTitle: "Chcete přijet se skupinou do hotelu Hotel Camprodon?",
        formContent: "Vyplňte tento formulář a pošlete nám svou žádost. Ozveme se vám co nejdříve.",
        languageValue: "cs",
        checkboxHref: "/cs/zasady-ochrany-soukromí",
    },
    ru: {
        heroImageAlt: "Группы и спортсмены в Hotel Camprodon",
        heroSmallTitle: "Отдых группой на лоне природы!",
        heroTitle: "Группы и спортсмены в Hotel Camprodon",
        presentationSmallTitle: "Остановитесь группой в Hotel Camprodon",
        presentationTitle: "Отель для групп и спортсменов",
        presentationContent: <>{"Hotel Camprodon готов "}<strong>принимать группы</strong>{" и учитывать ваши потребности."}</>,
        fullSliderImgAlt: "Отель для групп и спортсменов",
        fullSliderImgAlt2: "Отель для групп и спортсменов",
        fullSliderImgAlt3: "Отель для групп и спортсменов",
        sectionHeadSubtitle: "Приезжайте в Кампродон группой",
        sectionHeadTitle: "Мы готовы принимать группы и спортсменов",
        sectionHeadTexts: <><p>{"Мы рады принимать "}<strong>сборы команд</strong>{" по футболу, баскетболу, катанию на коньках... а также компании друзей и "}<strong>спортсменов</strong>, занимающихся маунтинбайком или шоссейным велоспортом. У нас есть гараж и место для подготовки велосипедов.</p><br /></>,
        list: "Специальные меню",
        list2: <>{"Для групп мы подстраиваемся под ваш "}<strong>распорядок</strong>{" и "}<strong>особенности питания</strong>{" и предлагаем специальные меню."}</>,
        formTitle: "Хотите приехать группой в Hotel Camprodon?",
        formContent: "Заполните эту форму и отправьте нам заявку. Мы свяжемся с вами в кратчайшие сроки.",
        languageValue: "ru",
        checkboxHref: "/ru/politika-otmeny",
    },
    sv: {
        heroImageAlt: "Grupper och idrottare på Hotel Camprodon",
        heroSmallTitle: "Njut av boende mitt i naturen tillsammans med din grupp!",
        heroTitle: "Grupper och idrottare på Hotel Camprodon",
        presentationSmallTitle: "Bo i grupp på Hotel Camprodon",
        presentationTitle: "Hotell för grupper och idrottare",
        presentationContent: <>{"Hotel Camprodon är redo att "}<strong>ta emot grupper</strong>{" och tillgodose era behov."}</>,
        fullSliderImgAlt: "Hotell för grupper och idrottare",
        fullSliderImgAlt2: "Hotell för grupper och idrottare",
        fullSliderImgAlt3: "Hotell för grupper och idrottare",
        sectionHeadSubtitle: "Kom till Camprodon i grupp",
        sectionHeadTitle: "Vi är redo att ta emot grupper och idrottare",
        sectionHeadTexts: <><p>{"Vi tar gärna emot "}<strong>träningsläger för lag</strong>{" inom fotboll, basket, skridsko... samt kompisgäng och "}<strong>idrottare</strong>{" som cyklar mountainbike eller landsväg. Vi har garage och plats att serva era cyklar."}</p><br /></>,
        list: "Anpassade menyer",
        list2: <>{"För grupper anpassar vi oss efter era "}<strong>tider</strong>{" och "}<strong>kostbehov</strong>{" och erbjuder specialmenyer."}</>,
        formTitle: "Vill du komma i grupp till Hotel Camprodon?",
        formContent: "Fyll i formuläret och skicka din förfrågan. Vi kontaktar dig så snart som möjligt.",
        languageValue: "sv",
        checkboxHref: "/sv/privacy-policy",
    },
};

export default textos;
